import React from "react";

export default () => {
  return <h1>Szakképzés index page</h1>;
};
